import * as React from "react";
import { connect } from "react-redux";
import { find } from "lodash";

import { RootState, Dispatch } from "../../../store/types";
import { Portfolio, PortfolioCategory as Category } from "../../../models";
import * as selectors from "../selectors";
import * as actions from "../actions";
import PortfolioItem from "./PortfolioItem";
import PortfolioView from "./Portfolio";
import PortfolioFilter from "./PortfolioFilter";

export interface PortfolioCarouselContainerProps {
  categories: Category[];
  activeCategory: number;
  portfolios: Portfolio[];
  fetchPortfolios: () => void;
  fetchCategories: () => void;
  selectCategory: (id: number) => () => void;
}

interface PortfolioCarouselContainerState {
  dropdownOpen: boolean;
}

class PortfolioCarouselContainer extends React.Component<
  PortfolioCarouselContainerProps,
  PortfolioCarouselContainerState
> {
  constructor(props: PortfolioCarouselContainerProps) {
    super(props);

    this.state = {
      dropdownOpen: false,
    };
  }

  public componentDidMount() {
    if (!this.props.portfolios.length) {
      this.props.fetchPortfolios();
    }
    if (!this.props.categories.length) {
      this.props.fetchCategories();
    }
  }

  private renderItems = () =>
    this.props.portfolios.map(portfolio => (
      <PortfolioItem key={portfolio.id} portfolio={portfolio} />
    ));

  private renderActiveFilter = () =>
    find(
      this.props.categories,
      category => category.id === this.props.activeCategory,
    );

  private renderFilters = () => [
    <PortfolioFilter
      key={0}
      portfolioCategory={{ id: 0, name: "Tất cả" }}
      handleClick={() => this.handleClick(0)}
      active={this.props.activeCategory === 0}
    />,
    ...this.props.categories.map(category => (
      <PortfolioFilter
        key={category.id}
        portfolioCategory={category}
        handleClick={() => this.handleClick(category.id)}
        active={this.props.activeCategory === category.id}
      />
    )),
  ];

  private handleClick = (id: number) => {
    this.setState({
      dropdownOpen: false,
    });
    this.props.selectCategory(id);
  };

  private handleOpenDropdown = () => {
    this.setState({
      dropdownOpen: true,
    });
  };

  public render() {
    return (
      <PortfolioView
        filters={this.renderFilters()}
        activeFilter={this.renderActiveFilter()}
        dropdownOpen={this.state.dropdownOpen}
        toggleDropdown={this.handleOpenDropdown}
      >
        {this.renderItems()}
      </PortfolioView>
    );
  }
}

const mapStateToProps = (
  state: RootState,
): Partial<PortfolioCarouselContainerProps> => ({
  categories: selectors.categories(state),
  activeCategory: selectors.activeCategory(state),
  portfolios: selectors.filteredPortfolios(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCategories: () => dispatch(actions.fetchCategories()),
  fetchPortfolios: () => dispatch(actions.fetchPortfolios()),
  selectCategory: (id: number) => dispatch(actions.setChosenCategory(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  PortfolioCarouselContainer,
);



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/components/PortfolioCarouselContainer.tsx